import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";

@Injectable()
export class AnnotationService {
  env: any = environment;

  constructor(private http: HttpClient, private router: Router) {}

  getAnnotationsByProjectId(projectId) {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("projectId", projectId);
      this.http
        .get<any>(this.env.managirUrl + "/annotations", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.AnnotationResponse.annotations);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  getAnnotationByShortId(shortId) {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("shortId", shortId);
      this.http
        .get<any>(this.env.managirUrl + "/annotations", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.AnnotationResponse.annotations[0]);
        })
        .catch((error) => {
          console.log(error);
          /**
           * check if user has access on project and if project does exist
           */
          if (error.status === 404 || error.status === 403) {
            this.router.navigate(["/" + error.status]);
          }
          reject(error);
        });
    });
  }

  createAnnotation(annotation) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/annotations", annotation, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          console.log(response);
          resolve(response.AnnotationResponse.annotations[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  updateAnnotation(annotation) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(
          this.env.managirUrl + "/annotations/" + annotation._id,
          annotation,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteAnnotationById(annotationId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(this.env.managirUrl + "/annotations/" + annotationId, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/annotation/annotation.service.ts